import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';

const PartnerDataTable = (props) => {

    const gridRef = useRef()
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    const rowData = props.data 
    
    if(props.data){
        console.log("Props", props.data)
    }

    const footerRow = {
        resourse_name: "Total",
        First_Time_Usres: rowData&&rowData.reduce((total, row) => total + row.First_Time_Usres, 0),
        Engaged_Users: rowData&&rowData.reduce((total, row) => total + row.Engaged_Users, 0),
    };

    const [columnDefs, setColumnDefs] = useState([
        {
            field: "resourse_name",
            headerName: "Partner Name",
            width: 400,
            cellRenderer: (params) => {
                const resourseName = params.value || "Not Provided";
                if (resourseName === "Total") {
                  return <div style={{ textAlign: "right" }}>{resourseName}</div>;
                } else {
                  return resourseName;
                }
              },
        },
        {
            field: "First_Time_Usres",
            headerName: "No of First Time User",
            flex: 1,
            sortable: true,
            pinnedBottomRowCellRenderer: "agGroupCellRenderer",
        },
        {
            field: "Engaged_Users",
            headerName: "No of Engaged User",
            flex: 1,
            sortable: true,
            pinnedBottomRowCellRenderer: "agGroupCellRenderer",
        },
    ]);

    const gridOptions = useMemo(() => ({
        suppressScrollOnNewData: true,
    }), []);

  return (
    <div style={{
        height: "50vh",
    }}>
        <div style={{ height: "100%", boxSizing: "border-box" }}>
            <div style={gridStyle} className="ag-theme-material">
                <AgGridReact ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    pinnedBottomRowData={[footerRow]}
                    gridOptions={gridOptions}
                    overlayNoRowsTemplate={
                        '<span class="ag-overlay-loading-center">loading...</span>'
                    }
                    rowClassRules={{
                        'total-row': 'data.resourse_name === "Total"'
                    }}
                >
                </AgGridReact>
            </div>
        </div>
    </div>
  )
}

export default PartnerDataTable
